import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CommonDropdown from '../../../../components/common-dropdown/CommonDropdown';
import ArchiveContentList from './ArchiveContentList';
import {
  searchActiv8Projects,
  searchDeletedActiv8Content,
} from '../../../../redux/settings/activ8/activ8SettingsActions';
import { setSelectedProjectId } from '../../../../redux/settings/activ8/activ8SettingsReducer';

import scss from './Archive.module.scss';

function Archive() {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();

  const projects = useSelector((state) => state.activ8Settings.projects);
  const isProjectsLoading = useSelector((state) => state.activ8Settings.isProjectsLoading);
  const selectedProjectId = useSelector((state) => state.activ8Settings.selectedProjectId);
  const { page, size, sort } = useSelector((state) => state.activ8Settings.tableSettings);

  const projectOptions = useMemo(
    () =>
      projects.map((project) => ({
        label: project.projectName,
        value: project.id,
      })),
    [projects],
  );

  useEffect(() => {
    dispatch(searchActiv8Projects());
  }, [dispatch]);

  useEffect(() => {
    if (!selectedProjectId) {
      return;
    }

    dispatch(searchDeletedActiv8Content());
  }, [dispatch, selectedProjectId, page, size, sort]);

  const handleSelectProject = (projectId) => {
    dispatch(setSelectedProjectId(projectId));
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.filters}>
        <CommonDropdown
          options={projectOptions}
          value={selectedProjectId ?? ''}
          onSelect={handleSelectProject}
          placeholder={t('selectActiv8Project')}
          isFilterable
          isLoading={isProjectsLoading}
          maxWidth={280}
          name='activ8-archive-project'
          size='sm'
        />
        {!selectedProjectId ? <p className={scss.projectHint}>{t('selectProjectToViewArchive')}</p> : null}
      </div>

      {selectedProjectId ? <ArchiveContentList /> : null}
    </div>
  );
}

export default Archive;
